import React__default, { useRef, useState, useMemo } from 'react';
import { i as isSameDay } from '../../chunks/bundle-D82dEh7Z.js';
import Icon, { IconTypes, IconColors } from '../../ui/Icon.js';
import PlaceHolder, { PlaceHolderTypes } from '../../ui/PlaceHolder.js';
import { u as useOpenChannelContext } from '../../chunks/bundle-C2pIFEfI.js';
import OpenChannelMessage from './OpenChannelMessage.js';
import { MessageProvider } from '../../Message/context.js';
import { u as useHandleOnScrollCallback } from '../../chunks/bundle-CrtC72UO.js';
import { compareMessagesForGrouping } from '../../Channel/utils/compareMessagesForGrouping.js';
import { u as useSendbird } from '../../chunks/bundle-DloqDvm2.js';
import { u as useLocalization } from '../../chunks/bundle-BSUtC3cw.js';
import '../../chunks/bundle-RVsnVYbw.js';
import '../../chunks/bundle-j5GfJ6DZ.js';
import '../../chunks/bundle-idC_wVZi.js';
import '../../chunks/bundle-ZBp236Ey.js';
import '../../chunks/bundle-BjDPDV1u.js';
import '../../ui/Loader.js';
import '../../chunks/bundle-CnQtgeX8.js';
import '../../chunks/bundle-S7XE7Lfi.js';
import '../../chunks/bundle-DwbhjuJz.js';
import '../../chunks/bundle-u2dy86rx.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-B7LMd75S.js';
import '../../chunks/bundle-X0vBfD3T.js';
import '../../chunks/bundle-BlgLvEI8.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-Cj_4CfJM.js';
import '../../chunks/bundle-B4W1Qw_4.js';
import 'react-dom';
import '../../chunks/bundle-DvCKSiBl.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-BC1GKYVu.js';
import '../../chunks/bundle-C6g3HNED.js';
import '@sendbird/chat/groupChannel';
import '../../chunks/bundle-DNwRc4lK.js';
import '../../ui/OpenchannelUserMessage.js';
import '../../chunks/bundle-2OseAMr7.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-BB95aNhx.js';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-EMEHizdG.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-Bzoj1u3h.js';
import '../../ui/UserProfile.js';
import '../../sendbirdSelectors.js';
import '../../chunks/bundle-Dw9XRtxR.js';
import '../../chunks/bundle-Chq4dUQK.js';
import '../../chunks/bundle-CsFWohR-.js';
import '../../ui/OpenChannelAdminMessage.js';
import '../../ui/OpenchannelOGMessage.js';
import '../../ui/LinkLabel.js';
import '../../chunks/bundle-CclIyWE2.js';
import '../../chunks/bundle-CSKhnQl7.js';
import '../../ui/MentionLabel.js';
import '../../ui/OpenchannelThumbnailMessage.js';
import '../../ui/OpenchannelFileMessage.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-CyIWMcD_.js';
import '../../ui/DateSeparator.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-dyq0aH11.js';
import '../../chunks/bundle-CPQL3IZE.js';
import '../../chunks/bundle-DRAooF75.js';
import 'dompurify';
import '../../chunks/bundle-CGAxlcUv.js';
import '../../chunks/bundle-xdZcjYxt.js';
import '../../chunks/bundle-DEv-umdP.js';
import '../../ui/FileViewer.js';
import '../../chunks/bundle-DTF9UGbO.js';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-B19WxiWc.js';
import '../../chunks/bundle-B0tvBFBn.js';
import '../../chunks/bundle-Jo2fwos6.js';
import '@sendbird/chat/message';

function OpenChannelMessageList(props, ref) {
    var _a = useOpenChannelContext(), _b = _a.isMessageGroupingEnabled, isMessageGroupingEnabled = _b === void 0 ? true : _b, allMessages = _a.allMessages, hasMore = _a.hasMore, onScroll = _a.onScroll;
    var state = useSendbird().state;
    var stringSet = useLocalization().stringSet;
    var userId = state.config.userId;
    var localRef = useRef(null);
    var scrollRef = ref || localRef;
    var _c = useState(false), showScrollDownButton = _c[0], setShowScrollDownButton = _c[1];
    var scrollToBottom = function () {
        if (scrollRef && 'current' in scrollRef && scrollRef.current) {
            scrollRef.current.scrollTo(0, scrollRef.current.scrollHeight);
            setShowScrollDownButton(false);
        }
    };
    var handleOnScroll = useHandleOnScrollCallback({
        setShowScrollDownButton: setShowScrollDownButton,
        hasMore: hasMore,
        onScroll: onScroll,
        scrollRef: scrollRef,
    });
    var memoizedMessageList = useMemo(function () {
        var _a;
        if (allMessages.length > 0) {
            return (allMessages.map(function (message, index) {
                var _a;
                var previousMessage = allMessages[index - 1];
                var nextMessage = allMessages[index - 1];
                var previousMessageCreatedAt = previousMessage && previousMessage.createdAt;
                var currentCreatedAt = message === null || message === void 0 ? void 0 : message.createdAt;
                // https://stackoverflow.com/a/41855608
                var hasSeparator = !(previousMessageCreatedAt && (isSameDay(currentCreatedAt, previousMessageCreatedAt)));
                var _b = isMessageGroupingEnabled
                    ? compareMessagesForGrouping(previousMessage, message, nextMessage, stringSet)
                    : [false, false], chainTop = _b[0], chainBottom = _b[1];
                var isByMe = ((_a = message === null || message === void 0 ? void 0 : message.sender) === null || _a === void 0 ? void 0 : _a.userId) === userId;
                var key = (message === null || message === void 0 ? void 0 : message.messageId) || (message === null || message === void 0 ? void 0 : message.reqId);
                return (React__default.createElement(MessageProvider, { message: message, isByMe: isByMe, key: key },
                    React__default.createElement(OpenChannelMessage, { message: message, chainTop: chainTop, chainBottom: chainBottom, hasSeparator: hasSeparator, renderMessage: props === null || props === void 0 ? void 0 : props.renderMessage })));
            }));
        }
        return (((_a = props === null || props === void 0 ? void 0 : props.renderPlaceHolderEmptyList) === null || _a === void 0 ? void 0 : _a.call(props)) || (React__default.createElement(PlaceHolder, { className: "sendbird-openchannel-conversation-scroll__container__place-holder", type: PlaceHolderTypes.NO_MESSAGES })));
    }, [allMessages]);
    return (React__default.createElement("div", { className: "sendbird-openchannel-conversation-scroll" },
        React__default.createElement("div", { className: "sendbird-openchannel-conversation-scroll__container" },
            React__default.createElement("div", { className: "sendbird-openchannel-conversation-scroll__container__padding" }),
            React__default.createElement("div", { className: [
                    'sendbird-openchannel-conversation-scroll__container__item-container',
                    (allMessages.length > 0) ? '' : 'no-messages',
                ].join(' '), onScroll: handleOnScroll, ref: scrollRef }, memoizedMessageList)),
        showScrollDownButton && (React__default.createElement("div", { className: "sendbird-openchannel-conversation-scroll__container__scroll-bottom-button", onClick: scrollToBottom, onKeyDown: scrollToBottom, tabIndex: 0, role: "button" },
            React__default.createElement(Icon, { width: "24px", height: "24px", type: IconTypes.CHEVRON_DOWN, fillColor: IconColors.CONTENT })))));
}
var OpenChannelMessageList$1 = React__default.forwardRef(OpenChannelMessageList);

export { OpenChannelMessageList$1 as default };
//# sourceMappingURL=OpenChannelMessageList.js.map
